import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { TaskFragments } from '../../graphql/task.graphql';
import { Task } from '../../types/task';
import { taskSlice } from '../../context/TaskContext';
import { useAppDispatch } from '../../ui/pages/store';

const taskSubscription = gql`
  subscription taskNotification($companyId: String!) {
    taskNotification(companyId: $companyId) {
      companyId
      entities {
        ...Task
      }
      topic
      date
    }
  }
  ${TaskFragments.task}
`;

export class TaskNotificationResponse extends forNotification<Task>('taskNotification') {}

export default function TaskNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: taskNotification } = useSubscription<TaskNotificationResponse>(taskSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleTaskNotification = (notification?: TaskNotificationResponse) => {
    if (!notification?.taskNotification) return;
    const taskNotification = notification.taskNotification;

    switch (taskNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(taskSlice.actions.add(taskNotification.entities));
        break;
      case 'DELETE':
        dispatch(taskSlice.actions.delete(taskNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleTaskNotification(taskNotification);
  }, [taskNotification]);

  return <></>;
}
